'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
var useEditCard = require('./useEditCard.js');
var React = require('react');
var Button = require('../../../components/Button/Button.js');
require('@babel/runtime/helpers/defineProperty');
require('../../../components/Button/StatisticsButton.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Edit card submit button
 *
 * Provides a button to submit the card.
 */
var EditCardSubmitButton = react.forwardRef(function (props, ref) {
  var _useEditCardContext = useEditCard.useEditCardContext(),
    getSubmitButtonProps = _useEditCardContext.getSubmitButtonProps;
  return /*#__PURE__*/React__default["default"].createElement(Button.Button, getSubmitButtonProps(props, ref));
});
EditCardSubmitButton.displayName = 'EditCardSubmitButton';
exports.EditCardSubmitButton = EditCardSubmitButton;